var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSpaceil = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    "data-bbox": "-0.062 -0.008 326.042 77.72",
    viewBox: "-0.062 -0.008 326.042 77.72",
    "data-type": "color",
    role: "presentation",
    "aria-hidden": "true",
    "aria-label": "",
    id: "svg12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs12"
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#000000",
      strokeWidth: 7.55906
    },
    id: "rect12",
    width: 369.04782,
    height: 99.216553,
    x: -21.564915,
    y: -10.756276
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.35 27.87c-3.53 0-5.83 1.29-5.83 3.7 0 8 21.08 3.64 21 17.72 0 7.35-6.4 11.61-15 11.61a25.47 25.47 0 01-16.6-6.28l3.14-6.34c4 3.59 9.36 5.78 13.57 5.78s6.73-1.57 6.73-4.32c0-8.19-21.09-3.53-21.09-17.5C99.27 25.4 105.16 21 114 21a26.73 26.73 0 0114.19 4.16l-3 6.5c-4.21-2.52-8.75-3.81-11.78-3.81",
    fill: "#ffffff",
    id: "path1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.22 27.81a13 13 0 100 26.08 15.73 15.73 0 0010.66-4.6l4.43 4.94A22.42 22.42 0 01224.83 61c-11.55 0-20.47-8.7-20.47-20s9-19.79 20.75-19.79a21.8 21.8 0 0115.14 6.28l-4.37 5.49a14.76 14.76 0 00-10.66-5.1",
    fill: "#ffffff",
    id: "path2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M274.01 21.36v6.56h-21.26v9.71h19.07v6.56h-19.07v9.87h21.93v6.56h-29.44V21.36h28.77z",
    id: "path3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0074bb",
    d: "M292.4 21.37v39.25h-8.86V21.37h8.86z",
    id: "path4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0074bb",
    d: "M309.16 21.37v31.51h16.82v7.74H300.3V21.37h8.86z",
    id: "path5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M188.55 21.36h-7.8l-17.22 39.26h7.8l3.48-8.3 2.69-6.45 6.95-16.49 5.43 13.07h-3.7l-2.8 6.62h9.26l4.83 11.55h8.07l-16.99-39.26z",
    id: "path6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.7 21.36h-16.1v39.26h7.52v-32.7h8.18c5.61 0 8.81 2.36 8.81 7.18s-3.2 7.35-8.81 7.35h-1v6.62h1.38c9.87 0 15.53-5.22 15.53-14.19 0-8.64-5.66-13.52-15.53-13.52",
    fill: "#ffffff",
    id: "path7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.21 52.16a29.76 29.76 0 0148.32-33A30.22 30.22 0 0162 23.34l6.18-4.62a37.48 37.48 0 00-65 36.66z",
    fill: "#ffffff",
    id: "path8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.62 22.71l-.75 2.1-4.22 5.77A29.78 29.78 0 0137.48 70a29 29 0 01-4.07-.29l-7.68 6.11a37.48 37.48 0 0044.89-53.11",
    fill: "#ffffff",
    id: "path9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.63 11.13A12.05 12.05 0 0073.94 9a15.13 15.13 0 00-3.82-5.24 14.31 14.31 0 00-3.63-2.26A19.58 19.58 0 0058.41 0a29.81 29.81 0 00-7.94 1.21 29.21 29.21 0 017.91-.36A18.58 18.58 0 0165.74 3a12.29 12.29 0 012.91 2.28 12.48 12.48 0 012 3 14 14 0 01.71 1.72 8.62 8.62 0 01.37 1.69 13.25 13.25 0 01-.09 3.55 26.54 26.54 0 01-2.33 7.07 55.27 55.27 0 01-3.82 6.66 109.4 109.4 0 01-9.62 12.26 248.87 248.87 0 01-22.63 21.84c-4.18 3.61-8.44 7.12-12.76 10.57a37.39 37.39 0 0011.6 3.68q3.8-3.73 7.49-7.57a257.78 257.78 0 0021.16-24.61 117.47 117.47 0 008.88-13.76 60.08 60.08 0 003.44-7.56 30.07 30.07 0 001.88-8.28 16 16 0 00-.3-4.41",
    fill: "#0074bb",
    id: "path10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73 9.35a10.12 10.12 0 00-2.59-5.14 12.64 12.64 0 00-4.59-3A17.83 17.83 0 0060.67.08a28.9 28.9 0 00-10.2 1.14 28.34 28.34 0 0110.06 0 16.18 16.18 0 014.63 1.54 10.71 10.71 0 013.6 2.93 7.52 7.52 0 011.53 4 8.19 8.19 0 01-.17 2.15 10.07 10.07 0 01-.7 2.09 15.89 15.89 0 01-2.53 3.81A25.83 25.83 0 0163.45 21c-1.23 1-2.62 1.95-4 2.93s-2.75 1.89-4.15 2.81q-4.21 2.75-8.56 5.3C41 35.44 35 38.61 29 41.63s-12.13 5.86-18.27 8.62C8 51.42 5.29 52.63 2.54 53.78a37.8 37.8 0 005 9c2.48-1.31 5-2.65 7.42-4 6-3.33 12-6.7 17.87-10.31s11.65-7.3 17.27-11.28q4.23-3 8.32-6.16c1.37-1.06 2.71-2.15 4-3.25s2.65-2.21 3.95-3.51A30.93 30.93 0 0070 20.1a18.84 18.84 0 002.56-5 12.31 12.31 0 00.61-2.83A10.66 10.66 0 0073 9.35",
    fill: "#0074bb",
    id: "path11"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSpaceil);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/spaceil.d03eb3e2517576f28d7ff8f6c8cca7a1.svg";